import { render, staticRenderFns } from "./ServerMonthly.vue?vue&type=template&id=4f38c757"
import script from "./ServerMonthly.vue?vue&type=script&lang=js"
export * from "./ServerMonthly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports